// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT, validLicenceNumber } from '../../../constants/globalConstants'
import { fileChangedHandler, isLoggedIn, isPermissionExist, perkingParkingTime, restrictSpecialChar, sortPortalPermissionByKey } from '../../../utils/helper'
import { getFacilityList, permitRateList } from '../../../redux/actions/BasicInfoAction'
import { Circles } from 'react-loader-spinner'
import FileUpload from '../../../components/fileUpload/FileUpload'
import { getVehicleDataList, getVehicleModelList } from '../../../redux/actions/VehicleListAction'
import './home.css'
import { useNavigate, useParams } from 'react-router-dom'
import URL from '../../../constants/urls'
import debounce from 'lodash/debounce'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
// import moment from 'moment'


function Home(props) {
	const { setPage, setIdProof, idProof, dispatch,
		formData, setFormData, formError, partnerDetails,
		vehicleListArray,
		setVehicleListArray,
		setvehicleCount,
		vehicleCount,
		VehiclePrev,
		loader
	} = props
	const { facility } = useParams()

	const [resident, setResident] = useState()
	const [faclityList, setFaclityList] = useState(EMPTY_ARRAY)
	const [selectedFaclity, setSelectedFacilty] = useState(EMPTY_ARRAY)
	const [permitPrices, setPermitPrices] = useState(EMPTY_ARRAY)
	const [permitList, setPermit] = useState(EMPTY_ARRAY)
	const [permitRateError, setPermitRateError] = useState('')
	const [idErrProof, setIdErrProof] = useState({})
	const partner = window.location.toString().split('/')[3]
	const promotion = window.location.toString().split('/')[4]
	// const [showRemoveButton, setRemoveButtonShowKey] = useState('')
	const [error, setError] = useState(false)
	const [accessPermissions, setAccessPermissions] = useState('')
	const [entryDateTime, setEntryDateTime] = useState(new Date())


	// vehicle
	// const [isVehicleTableVisible, setIsVehicleTableVisible] = useState(false)
	// const [vehicleList, setVehicleList] = useState(EMPTY_ARRAY)
	const [vehicleDetailsList, setVehicleDetailsList] = useState(EMPTY_ARRAY)
	const [vehicleMakeList, setVehicleMakeList] = useState(EMPTY_ARRAY)
	const [vehicleModelList, setvehicleModelList] = useState(EMPTY_ARRAY)
	const [vehicleCountList, setvehicleCountList] = useState(EMPTY_ARRAY)

	const zoneList = [{ val: 'A', name: 'A' }, { val: 'B', name: 'B' }, { val: 'C', name: 'C' }]


	// for disbaled functionallty 
	const [loginData, setLoginData] = useState(EMPTY_OBJECT)

	const navigate = useNavigate()
	const searchParams = new URLSearchParams(location.search)

	useEffect(() => {
		if (facility) {
			setFormData({ ...formData, ['facility_id']: facility })
		}
	}, [EMPTY_ARRAY, facility])

	useEffect(() => {
		getVehical()

	}, [EMPTY_ARRAY])

	useEffect(() => {
		if (!formData?.facility_id) {
			localStorage.removeItem('facility')
		}
		setFormData({ ...formData, ['zone']: 'A' })
		localStorage.setItem('zone', formData?.zone ? formData?.zone : 'A')


		if (formData?.facility_id || facility) {
			retrievePermitData(formData?.license_number, formData?.facility_id, faclityList)
		}
		if (formData?.permit_type) {
			const selectedPermit = permitList?.filter((item) => item?.id == Number(formData?.permit_type))
			setPermitTypes(selectedPermit)
		}
		if (formData?.license_number) {
			const userData = localStorage.getItem('userData') ? localStorage.getItem('userData') : '{}'
			const user = JSON.parse(userData)
			const license_number = user?.user?.license_number
			const handlingLicenseChange = {
				target: {
					value: isLoggedIn() ? license_number : formData?.license_number
				}
			}
			handleLicenceNumberChange(handlingLicenseChange)
		}
		setPage('home')
		dispatch(getFacilityList(partner)).then((res) => {
			setFaclityList(res)
			if (res.length == 1) {
				setSelectedFacilty(res[0])
				localStorage.setItem('facility', JSON.stringify(res[0]))
				setFormData({ ...formData, 'selFaclity': res[0], ['facility_id']: res[0]?.id })
				const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
				if (!isPermissionExist(getAccessPermissionData, 'Driving License')) {
					retrievePermitData(formData?.license_number, res[0]?.id, res)
				} else {
					retrievePermitData('', res[0]?.id, res)
				}
			} else {
				const selFaclity = res?.filter((item) => item?.id == Number(formData?.facility_id || facility))
				setSelectedFacilty(selFaclity[0])
				localStorage.setItem('facility', JSON.stringify(selFaclity[0]))
				setFormData({ ...formData, 'selFaclity': selFaclity[0], ['facility_id']: selFaclity[0]?.id })
				const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
				if (!isPermissionExist(getAccessPermissionData, 'Driving License')) {
					retrievePermitData(formData?.license_number, selFaclity[0]?.id, res)
				} else {
					retrievePermitData('', selFaclity[0]?.id, res)
				}
			}
			// if (formData?.facility_id) {
			// 	const selFaclity = res?.filter((item) => item?.id == Number(formData?.facility_id))
			// 	if (selFaclity[0] && selFaclity[0]?.full_name != '') {
			// 		setSelectedFacilty(selFaclity[0])
			// 		localStorage.setItem('facility', JSON.stringify(selFaclity[0]))
			// 	}
			// } else {
			// 	// setSelectedFacilty(res[0])
			// 	localStorage.setItem('facility', JSON.stringify(res[0]))
			// 	if (res[0]?.id) {
			// 		retrievePermitData('', res[0]?.id,res)
			// 	}
			// }
		})
		if (isLoggedIn()) {
			const userData = localStorage.getItem('userData')
			const user = JSON.parse(userData)
			// save loginUserData
			setLoginData(user?.user)
			const license_number = user?.user?.license_number ? user?.user?.license_number : formData?.license_number

			formData['license_number'] = license_number
			setFormData({ ...formData })

			// if ((vehicles?.length > 0 && vehicles[0]?.license_plate != '') && !formData?.vehicleSelected) {
			// 	// dougth full change vehcle table true kiya hai
			// 	// setIsVehicleTableVisible(false)
			// } else {
			// 	setIsVehicleTableVisible(true)
			// }
			if (VehiclePrev) {
				dispatch(getVehicleDataList()).then((res) => {
					let payloadData = { ...formData }
					let vehicleCopy = []
					res?.data.map((value) => {
						let copy = { ...value }
						let modelData = vehicleDetailsList?.make?.filter((v) => v.name == copy?.make)
						let modelList = (modelData?.length != 0 ? modelData?.[0]?.mst_model : [])
						let filteredmakemodelList = modelList?.filter((v) => v.name == copy?.model)
						// // setvehicleModelList(modelData[0]?.mst_model)
						let check = modelList?.some((value) => value?.name == 'Others')
						if (!check && modelList != undefined) {
							modelList.unshift({
								'id': 'Others',
								'make_id': 'Others',
								'name': 'Others'
							})
						}
						copy['license_plate'] = copy?.license_plate_number
						copy['maketext'] = copy?.make ? copy?.make : ''
						copy['make'] = modelData?.length == 0 ? 'Others' : copy?.make ? copy?.make : ''
						copy['othermake'] = modelData?.length == 0 ? true : false
						copy['othermodel'] = filteredmakemodelList?.length == 0 ? true : false
						copy['modeltext'] = copy?.model ? copy?.model : ''
						copy['model'] = filteredmakemodelList?.length == 0 ? 'Others' : copy.model ? copy?.model : ''
						copy['vehicleList'] = modelList != undefined ? modelList : vehicleModelList
						delete copy['license_plate_number']
						vehicleCopy.push(copy)
					})
					payloadData['vehicleList'] = vehicleCopy
					setvehicleCount(vehicleCopy.length)
					setvehicleCountList(vehicleCopy)
					setFormData(payloadData)
					setVehicleListArray(vehicleCopy)
					if (res?.data?.length == 5) {
						// dougth full change vehcle table true kiya hai
						// setIsVehicleTableVisible(false) 
						// setIsVehicleTableVisible(true)
					} else {
						// setIsVehicleTableVisible(true)
					}
				})
			}
		} else {
			// setIsVehicleTableVisible(true)
		}
	}, [vehicleDetailsList])



	useEffect(() => {
		if (partner && partner != 'navigating') {
			if (partner == 'worldport-la') {
				navigate(`/${partner}${URL?.BASE_RESPONSIVE_RESERVATION}`)
			}
		}
	}, [EMPTY_ARRAY, partner])

	useEffect(() => {
		const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
		setAccessPermissions(getAccessPermissionData)
	}, [EMPTY_ARRAY, partnerDetails])

	useEffect(() => {
		if (formData?.permit_type) {
			const selectedPermit = permitList?.filter((item) => item?.id == Number(formData?.permit_type))
			setPermitTypes(selectedPermit)
		}
	}, [EMPTY_ARRAY, permitList])





	const getVehical = () => {
		dispatch(getVehicleModelList(partnerDetails?.facilities?.[0]?.country_code)).then((res) => {
			let makeList = res.make
			makeList.unshift({
				'id': 'Others',
				'name': 'Others',
				'mst_model': [{
					'id': 'Others',
					'make_id': 'Others',
					'name': 'Others'
				}]
			})

			setVehicleMakeList(makeList)
			setVehicleDetailsList(res)
			// setValue('country', res.country[0].name)
			// if (BookingEdit) {
			// 	let model = (res?.make?.length > 0) && res?.make?.filter((v) => v?.name == BookingEditData?.vehical_details?.make)
			// 	setvehicleModelList(model[0]?.mst_model)
			// }

		})

	}


	// useEffect(() => {
	// 	permitList
	// 	const selectedPermit = faclityList?.filter((item) => item?.id == Number(value))
	// 	setPermitTypes()
	// }, [EMPTY_ARRAY, permitList])

	const retrievePermitData = (license_number, facility_id, facilities = []) => {
		if (facility_id) {
			const permitPayload = {
				'facility_id': facility_id,
				'is_promotion': promotion && promotion != '' && promotion == 'permittype2' ? '1' : searchParams?.get('permitID') ? '1' : '0',
				'driving_license': !isPermissionExist(accessPermissions, 'Driving License') ? license_number ? license_number?.trim() : '' : ''
			}
			// if (validLicenceNumber.test(license_number?.trim())) {
			dispatch(permitRateList(permitPayload)).then((res) => {
				if (res?.data?.length == 1) {
					let faclityList1 = (facilities && facilities?.length > 0) ? facilities : faclityList
					const selFaclity = (faclityList1 && faclityList1?.length > 0) && faclityList1?.filter((item) => item?.id == Number(facility_id))
					setFormData({ ...formData, ...{ permit_type: res?.data[0]?.id }, facility_id: facility_id, 'selFaclity': selFaclity[0], 'permit_type_name': res?.data?.[0]?.name ? res?.data?.[0]?.name : '' })
				}
				setPermit(res?.data)

			})
		}
	}


	const deb = useCallback(
		debounce((license_number, facility_id) => {
			retrievePermitData(license_number, facility_id, faclityList)
		}, 300),
		[])

	const handleLicenceNumberChange = (e) => {
		const { value } = e.target
		if (value?.length > 6 && value?.length < 14) {
			if (value?.length != 9) {
				if (validLicenceNumber.test(value?.trim())) {
					const licenseData = {
						resident: 'Non-Resident',
						license_number: value?.toUpperCase()
					}
					setResident('Non-Resident')

					setFormData({ ...formData, ...licenseData })
				} else {
					const licenseData = {
						resident: '',
						license_number: value?.toUpperCase()
					}
					setFormData({ ...formData, ...licenseData })
					setResident('Invalid License Number')
				}
			} else {
				const alpha = value?.slice(0, 1)
				const number = value?.slice(1, 9)
				if (/^[H]+$/.test(alpha) && /(\d{8})/g.test(number)) {
					const licenseData = {
						resident: 'Resident',
						license_number: value?.toUpperCase()
					}
					setFormData({ ...formData, ...licenseData })
					setResident('Resident')
				} else {
					if (validLicenceNumber.test(value?.trim())) {
						const licenseData = {
							resident: 'Non-Resident',
							license_number: value?.toUpperCase()
						}
						setFormData({ ...formData, ...licenseData })
						setResident('Non-Resident')
					} else {
						const licenseData = {
							resident: '',
							license_number: value?.toUpperCase()
						}
						setFormData({ ...formData, ...licenseData })
						setResident('Invalid License Number')
					}
				}
			}
			// Call Debounce
			deb(value, formData?.facility_id)
		} else {
			const licenseData = {
				resident: '',
				license_number: value?.toUpperCase()
			}
			setFormData({ ...formData, ...licenseData })
			setResident('')
		}
	}

	const handleInputFieldsData = (e, i) => {

		const { name, value } = e.target
		// const payloadData = { ...formData }
		const vehicleList = vehicleListArray?.slice()

		if (name === 'license_plate' || name == 'modeltext' || name == 'maketext' || name == 'color' || name == 'state_id') {
			vehicleList[i][name] = value
			setVehicleListArray(vehicleList)
			// setFormData({ ...payloadData })
		} else if (name == 'vehicle_type') {
			let vehicletypeData = vehicleDetailsList?.vehicletype?.filter((v) => v.name == value)
			vehicleList[i]['vehicle_type'] = vehicletypeData?.[0]?.name
			vehicleList[i]['vehicle_type_id'] = vehicletypeData?.[0]?.id
			setVehicleListArray(vehicleList)
		} else if (name === 'facility_id') {
			const selFaclity = faclityList?.filter((item) => item?.id == Number(value))
			setSelectedFacilty(selFaclity[0])
			setFormData({ ...formData, 'selFaclity': selFaclity[0], 'facility_id': value })

			if (selFaclity[0]) {
				retrievePermitData(formData?.license_number, value, faclityList)
				localStorage.setItem('facility', JSON.stringify(selFaclity[0]))
			} else {
				localStorage.setItem('facility', '{}')
				setPermitRateError('')
			}

		} else if (name == 'permit_type') {
			const selectedPermit = permitList?.filter((item) => item?.id == Number(value))
			if (value) {
				setPermitTypes(selectedPermit)
			}
			const updatedData = { ...formData, [name]: value, 'permit_rate': selectedPermit?.[0]?.permit_rate?.[0]?.rate, 'permit_rate_id': selectedPermit?.[0]?.permit_rate?.[0]?.id, 'permit_type_name': selectedPermit?.[0]?.name ? selectedPermit?.[0]?.name : '' }
			setFormData(updatedData)


		} else if (name == 'model') {
			vehicleList[i]['othermodel'] = (value == 'Others') ? true : false
			vehicleList[i][name] = value
			setVehicleListArray(vehicleList)
			// setFormData({ ...payloadData })
		} else if (name == 'make') {
			let modelData = vehicleDetailsList?.make?.filter((v) => v.name == value)
			let modelList = modelData[0].mst_model
			let makeData = vehicleMakeList?.filter((v) => v.name == value)
			// setvehicleModelList(modelData[0]?.mst_model)
			let check = modelList?.some((value) => value?.name == 'Others')
			if (!check) {
				modelList.unshift({
					'id': 'Others',
					'make_id': 'Others',
					'name': 'Others'
				})
			}
			setvehicleModelList(modelList)
			//   setVehicleMakeID(value)
			vehicleList[i][name] = value
			vehicleList[i]['vehicleList'] = modelList
			// setVehicleList([...vehicleList])
			vehicleList[i]['make_id'] = makeData?.[0]?.id != 'Others' ? makeData?.[0]?.id : 0
			vehicleList[i][name] = value
			vehicleList[i]['maketext'] = value == 'Others' ? '' : value
			vehicleList[i]['othermake'] = (value == 'Others') ? true : false
			vehicleList[i]['othermodel'] = (value == 'Others') ? true : false
			vehicleList[i]['vehicleList'] = modelData[0].mst_model.length > 0 ? modelData[0].mst_model : vehicleModelList

			//vehicleList[i]['vehicleList'] = vehicleModelList
			setVehicleListArray(vehicleList)
			// setFormData({ ...payloadData })
		}
		else {
			if (name == 'zone') {
				localStorage.setItem('zone', value)
			}
			setFormData({ ...formData, [name]: value })
		}
	}

	const handleEntryTime = (event) => {
		setEntryDateTime(event)
		setFormData({ ...formData, 'startDate': event })
	}

	const setPermitTypes = (selectedPermit) => {

		setResident(selectedPermit?.[0]?.name)
		const permit = selectedPermit?.[0]
		setPermitPrices(permit)
		const permitRate = permit?.permit_rate[0]
		if (permitRate?.name) {
			localStorage.setItem('permits', JSON.stringify(permitRate))
			const permitDetails = {
				permit_rate: permitRate?.rate,
				permit_rate_id: permitRate?.id,
				facility_id: permitRate?.facility_id,
				license_number: formData?.license_number ? formData?.license_number : '',
				permit_type: selectedPermit?.[0]?.id
			}
			setFormData({ ...formData, ...permitDetails })
			setPermitRateError('')
		} else {
			if (formData?.facility_id) {
				setPermitRateError('')
			} else {
				setPermitRateError('')
			}
			localStorage.setItem('permits', '{}')
		}
	}

	// const handleVehicleChange = (e) => {
	// 	const { value } = e.target
	// 	if (value != '') {
	// 		// Selected vehicle 
	// 		const selectedVehicle = vehicleList?.filter((vehicle) => vehicle?.license_plate_number == value)

	// 		// form vehicle list from here
	// 		const payloadData = { ...formData }

	// 		// condition check to know whether vehicle already exist in from list 
	// 		const conditionCheck = payloadData?.vehicleList?.map((el1) => vehicleList?.some((el2) => el2.license_plate_number === el1.license_plate))

	// 		// CONDITION FOR THE OBJECT ADD UPDATE 
	// 		if (payloadData?.vehicleList?.length < (5 - vehicleList?.length) && conditionCheck?.[0] == false) {
	// 			payloadData.vehicleList.unshift({ 'license_plate': selectedVehicle[0]?.license_plate_number, 'make': selectedVehicle[0]?.make, 'model': selectedVehicle[0]?.model, 'color': selectedVehicle[0]?.color })
	// 		} else if (payloadData?.vehicleList?.length <= 5 && conditionCheck?.[0] == true) {
	// 			payloadData.vehicleList[0]['license_plate'] = selectedVehicle[0]?.license_plate_number
	// 			payloadData.vehicleList[0]['make'] = selectedVehicle[0]?.make
	// 			payloadData.vehicleList[0]['model'] = selectedVehicle[0]?.model
	// 			payloadData.vehicleList[0]['color'] = selectedVehicle[0]?.color
	// 		} else if (payloadData?.vehicleList?.length == 5) {
	// 			setError('Maximum limit reached, Please remove one vehicle before adding!')
	// 		}

	// 		const updatedVehicleList = removeObjectsWithEmptyValues(payloadData.vehicleList, 'license_plate')
	// 		payloadData.vehicleList = updatedVehicleList
	// 		// CONDITION END 
	// 		payloadData['vehicleSelected'] = true
	// 		setFormData({ ...payloadData })
	// 	} else {
	// 		const payloadData = { ...formData }
	// 		// condition check to know whether vehicle already exist in from list 
	// 		const conditionCheck = payloadData?.vehicleList?.map((el1) => vehicleList?.some((el2) => el2.license_plate_number === el1.license_plate))

	// 		if (conditionCheck?.[0] == true) {
	// 			payloadData.vehicleList.shift()
	// 		}
	// 		// payloadData.vehicleList[0]['license_plate'] = ''
	// 		// payloadData.vehicleList[0]['make'] = ''
	// 		// payloadData.vehicleList[0]['model'] = ''
	// 		// payloadData.vehicleList[0]['color'] = ''
	// 		payloadData['vehicleSelected'] = false
	// 		setFormData({ ...payloadData })
	// 	}

	// }
	// const handleVehicleChange = (e) => {
	// 	const { value } = e.target
	// 	if (value != '') {
	// 		const selectedVehicle = vehicleList?.filter((vehicle) => vehicle?.license_plate_number == value)

	// 		let modelData = vehicleDetailsList?.make?.filter((v) => v.name == selectedVehicle[0]?.make)
	// 		if(modelData.length > 0) {
	// 			let modelList=modelData[0].mst_model
	// 			let check = modelList?.some((value) => value?.name == 'Others')
	// 				if(!check){
	// 					modelList.unshift({
	// 						'id': 'Others',
	// 						'make_id': 'Others',
	// 						'name': 'Others'
	// 				})
	// 			}
	// 		}

	// 		let makemodelList = (modelData?.length != 0 ? modelData?.[0]?.mst_model : [])
	// 		let filteredmakemodelList = makemodelList?.filter((v) => v.name == selectedVehicle[0]?.model)
	// 		const payloadData = { ...formData }
	// 		payloadData.vehicleList[0]['license_plate'] = selectedVehicle[0]?.license_plate_number
	// 		payloadData.vehicleList[0]['make'] = modelData?.length == 0 ? 'Others' : selectedVehicle[0]?.make ? selectedVehicle[0]?.make  : ''
	// 		payloadData.vehicleList[0]['maketext'] = selectedVehicle[0]?.make ? selectedVehicle[0]?.make  : ''
	// 		payloadData.vehicleList[0]['othermake'] = modelData?.length == 0 ? true  : false
	// 		payloadData.vehicleList[0]['othermodel'] = filteredmakemodelList?.length == 0 ? true  : false
	// 		payloadData.vehicleList[0]['model'] = filteredmakemodelList?.length == 0 ? 'Others' : selectedVehicle[0]?.model ? selectedVehicle[0]?.model : ''
	// 		payloadData.vehicleList[0]['modeltext'] = selectedVehicle[0]?.model ? selectedVehicle[0]?.model : ''
	// 		payloadData.vehicleList[0]['color'] = selectedVehicle[0]?.color
	// 		payloadData.vehicleList[0]['state_id'] = selectedVehicle[0]?.state_id
	// 		payloadData.vehicleList[0]['vehicleList'] = modelData.length > 0 ? modelData[0]?.mst_model : []
	// 		payloadData['vehicleSelected'] = true
	// 		setFormData({ ...payloadData })
	// 	} else {
	// 		const payloadData = { ...formData }
	// 		payloadData.vehicleList[0]['license_plate'] = ''
	// 		payloadData.vehicleList[0]['make'] = ''
	// 		payloadData.vehicleList[0]['maketext'] = ''
	//         payloadData.vehicleList[0]['modeltext'] = ''
	// 		payloadData.vehicleList[0]['model'] = ''
	// 		payloadData.vehicleList[0]['color'] = ''
	// 		payloadData.vehicleList[0]['state_id'] = ''
	// 		payloadData['vehicleSelected'] = false
	// 		setFormData({ ...payloadData })
	// 	}

	// }

	// const showVehicleTable = () => {
	// 	// const showVehicleTable = (e, key) => {

	// 	setRemoveButtonShowKey()
	// 	const payloadData = { ...formData }
	// 	const testToSeeAllErrorsAreEmpty = payloadData?.vehicleList.every((item) => item?.license_plate !== '')
	// 	if (isVehicleTableVisible && payloadData?.vehicleList?.length < (5 - vehicleList?.length) && testToSeeAllErrorsAreEmpty === true) {
	// 		payloadData?.vehicleList.push({ 'license_plate': '', 'make': '', 'model': '', 'color': '' , 'state_id': '' , 'othermake' : false , 'othermodel' : false , 'vehicleList' :  [] })
	// 		setFormData({ ...payloadData })
	// 		payloadData['vehicleSelected'] = false
	// 		setError('')
	// 	} else if (testToSeeAllErrorsAreEmpty === false) {
	// 		setError('Please enter the License plate, before adding a new vehicle!')
	// 	}
	// 	setIsVehicleTableVisible(true)
	// 	//  else if (payloadData.vehicleList?.length === 1) {
	// 	// 	payloadData.vehicleList[0]['license_plate'] = ''
	// 	// 	payloadData.vehicleList[0]['make'] = ''
	// 	// 	payloadData.vehicleList[0]['model'] = ''
	// 	// 	payloadData.vehicleList[0]['color'] = ''
	// 	// 	payloadData['vehicleSelected'] = false
	// 	// 	setFormData({ ...payloadData })
	// 	// }
	// }
	// const showVehicleTable = () => {
	// 	setIsVehicleTableVisible(true)
	// 	const payloadData = { ...formData }
	// 	if (payloadData?.vehicleList?.length === 0) {
	// 		payloadData?.vehicleList.push({ 'license_plate': '', 'make': '', 'model': '', 'color': '' })
	// 		setFormData({ ...payloadData })
	// 	} else if (payloadData.vehicleList?.length === 1) {
	// 		payloadData.vehicleList[0]['license_plate'] = ''
	// 		payloadData.vehicleList[0]['make'] = ''
	// 		payloadData.vehicleList[0]['model'] = ''
	// 		payloadData.vehicleList[0]['color'] = ''
	// 		payloadData['vehicleSelected'] = false
	// 		setFormData({ ...payloadData })
	// 	}
	// }

	// const addVehicle = () => {
	// 	const payloadData = { ...formData }
	// 	// checking the every object item is empty or not 
	// 	const testToSeeAllErrorsAreEmpty = payloadData?.vehicleList.every((item) => item?.license_plate !== '' && item?.make !== '' && item?.model !== '')
	// 	if (payloadData?.vehicleList.length <= 2 && testToSeeAllErrorsAreEmpty === true) {
	// 		payloadData?.vehicleList.push({ 'license_plate': '', 'make': '', 'model': '', 'color': '' })
	// 		setFormData({ ...payloadData })
	// 		setError('')
	// 	} else if (testToSeeAllErrorsAreEmpty === false) {
	// 		setError('Please Fill All The Input, Before Add Another Vehicle !')
	// 	}
	// }

	// const removeVehicleMake = () => {
	// 	setIsVehicleTableVisible(false)
	// 	const payloadData = { ...formData }
	// 	payloadData.vehicleList[0]['license_plate'] = ''
	// 	payloadData.vehicleList[0]['make_model'] = ''
	// 	payloadData['vehicleSelected'] = false
	// 	setFormData({ ...payloadData })
	// }

	const addVehicle = () => {
		// const payloadData = { ...formData }
		// // checking the every object item is empty or not 
		// const testToSeeAllErrorsAreEmpty = payloadData?.vehicleList.every((item) => item?.license_plate !== '')
		// if (payloadData?.vehicleList.length <= 4 && testToSeeAllErrorsAreEmpty === true) {
		// 	payloadData?.vehicleList.push({ 'license_plate': '', 'make': '', 'model': '', 'color': '', 'state_id': '', 'othermake': false, 'othermodel': false, 'vehicleList': [] })
		// 	setFormData({ ...payloadData })
		// 	setError('')
		// } else if (testToSeeAllErrorsAreEmpty === false) {
		// 	setError('Please enter the License plate, before adding a new vehicle!')
		// }
		const vehicleList = vehicleListArray.slice()
		// checking the every object item is empty or not 
		const testToSeeAllErrorsAreEmpty = vehicleList.every((item) => item?.license_plate !== '')
		if (vehicleList.length <= 5 && testToSeeAllErrorsAreEmpty === true) {
			vehicleList.push({ 'license_plate': '', 'make': '', 'model': '', 'color': '', 'state_id': '', 'othermake': false, 'othermodel': false, 'vehicleList': [], 'vehicle_number': '', vehicle_type: '', vehicle_type_id: '' })
			// setFormData({ ...payloadData })
			setVehicleListArray(vehicleList)
			setError('')
		} else if (testToSeeAllErrorsAreEmpty === false) {
			setError('Please enter the License plate, before adding a new vehicle!')
		}
	}
	const removeVehicleMake = (e, i) => {
		// const payloadData = { ...formData }
		// const vehicleList = payloadData?.vehicleList?.slice()
		// let findVeh = vehicleCountList?.some(val => val?.id == vehicleList[i]?.id)
		// if (findVeh) {
		// 	setvehicleCount(prev => prev - 1)
		// }
		// payloadData?.vehicleList?.splice(i, 1)
		// if (payloadData?.vehicleList?.length === 0) {
		// 	setIsVehicleTableVisible(false)
		// }
		// if (i == 0) {
		// 	payloadData['vehicleSelected'] = false
		// }
		// setFormData({ ...payloadData })
		const vehicleList = vehicleListArray.slice()
		let findVeh = vehicleCountList?.some(val => val?.id == vehicleList[i]?.id)
		if (findVeh) {
			setvehicleCount(prev => prev - 1)
		}
		vehicleList?.splice(i, 1)
		if (vehicleList?.length === 0) {
			// setIsVehicleTableVisible(false)
		}
		setVehicleListArray(vehicleList)
	}





	return (
		<div>
			<h4 className="text-center my-4 fw-bolder">Basic Information </h4>
			<div className="row g-2">
				<div className='col-sm-4'>
					<div className="mb-3 position-relative">
						<label className="form-label">Select Parking Location <span className='text-danger'> *</span></label>
						<select name="facility_id" id="facility_id" className="form-select" onChange={handleInputFieldsData} >
							{/* <option value={faclityList[0]?.id} selected={formData?.facility_id == faclityList[0]?.id}>{faclityList[0]?.full_name}</option> */}

							<option value={''}>Select Parking Location</option>
							{faclityList?.map((faclityListItem, faclityListIndex) => {
								return (
									<option value={faclityListItem?.id} selected={formData?.facility_id == faclityListItem?.id} key={faclityListIndex}>{faclityListItem?.full_name}</option>
								)
							})}
						</select>
						{!loader ? <span className='text-end small d-block mb-1'>
							<span className="form-text text-danger h-40">{permitRateError ? '' : ''}
							</span>
						</span> : null}
						<span className="form-text text-danger h-40">{formError == 'home' && !formData?.facility_id ? 'This field is required' : ''}</span>
					</div>


				</div>
				{partner == 'demo-parkengage' ? <div className="col-sm-3">
					<div className="mb-3 position-relative">
						<label className="form-label">Select Zone</label>
						<select name="zone" id="zone" className="form-select" onChange={handleInputFieldsData} >
							{/* <option value={faclityList[0]?.id} selected={formData?.zone == faclityList[0]?.id}>{faclityList[0]?.full_name}</option> */}

							{zoneList?.map((zoneListItem, index) => {
								return (
									<option key={index} value={zoneListItem?.val} selected={formData?.zone == zoneListItem?.val}>{zoneListItem?.name}</option>
								)
							})}
						</select>
					</div>


				</div> : null}


				<div className='col-sm-4'>
					<div className="mb-3 position-relative">
						<label className="form-label">Permit Type <span className='text-danger'> *</span></label>
						<select name="permit_type" id="permit_type" className="form-select" onChange={(e) => handleInputFieldsData(e, '')} >
							<option value={''}>Select Permit Type</option>
							{permitList?.map((permit, index) => {
								return (
									<option key={index} value={permit?.id} selected={formData?.permit_type == permit?.id}>{permit?.name}</option>
								)
							})}
						</select>
						<span className="form-text text-danger h-40">{formError == 'home' && !formData?.permit_type ? 'This field is required' : ''}</span>

					</div>


				</div>


				<div className='col-sm-4'>
					<div className="mb-3 yankeeFix ">
						<label className="form-label"> Start Date </label>
						<div className=' d-flex border align-items-center justify-content-between'>
							<DatePicker
								selected={entryDateTime}
								// isClearable
								onChange={(date) => handleEntryTime(date)}
								className="form-control border-0 flex-basis-1 "
								timeIntervals={15}
								autoComplete="off"
								id="entry_time"
								name="entry_time"
								// showTimeSelect
								dateFormat="MMMM d, yyyy"
								minDate={new Date()}
								onKeyDown={(e) => {
									e.preventDefault()
								}}
							// minTime={moment(entryDateTime).format('YYYY-MM-DD')>moment(new Date()).format('YYYY-MM-DD') ?setHours(setMinutes(entryDateTime,0), 0):setHours(setMinutes(entryDateTime.getMinutes(), moment(new Date()).format('ss')), entryDateTime.getHours())}
							// maxTime={setHours(setMinutes(entryDateTime, 30), 23)}
							/>
							<i className=' fa fa-calendar-alt text-gray me-2' style={{ 'margin-left': '-100px', 'z-index': '2000', 'pointer-events': 'none' }} ></i>
						</div>
						{/* <span className="form-text text-danger h-40">{formError == 'home' && !formData?.permit_type ? 'This field is required' : ''}</span> */}

					</div>


				</div>





				{!isPermissionExist(accessPermissions, 'Driving License') ?
					<div className="col-sm-3 col-12">
						<div className="mb-3 position-relative">
							<label className="form-label">Driver License Number </label>
							<input
								className="form-control "
								name="license_number"
								id="license_number"
								maxLength={13}
								value={formData?.license_number}
								minLength={1}
								placeholder="License Number"
								required=""
								onKeyDown={restrictSpecialChar}
								disabled={(!loginData?.license_number) ? false : true}
								type="text"
								// onBlur={() => retrievePermitData(formData?.license_number, formData?.facility_id, faclityList)}
								onChange={(e) => handleLicenceNumberChange(e, 'change', formData?.facility_id)}
							/>
							<span className='text-end small d-block mb-1'>
								{resident == 'checking...' ? <span><Circles
									height="15"
									width="15"
									color="var(--bs-primary)"
									ariaLabel="circles-loading"
									visible={true}
								/></span> : <span className={resident == 'Invalid License Number' ? 'form-text text-danger h-40' : 'form-text text-primary h-40'}><b>{formData?.license_number ? resident : ''}</b></span>}
								{/* <span className="form-text text-danger h-40">{formError == 'home' && !formData?.license_number ? 'This field is required' : (formError == 'home' && formData?.license_number?.length < 7) ? 'Please enter a valid license number' : ''}</span> */}
							</span>
							{/* <span className="form-text text-danger h-40">{formError == 'home' ? !formData?.license_number ? 'This field is required' : !validLicenceNumber.test(formData?.license_number?.trim()) ? 'Please enter a valid license number' : '' : ''}</span> */}
							{/* <span className="form-text text-danger h-40">{formError == 'home' && !formData?.license_number ? 'This field is required' : ''}</span> */}

						</div>
					</div> : null}
				{/* remove */}

				{!isPermissionExist(accessPermissions, 'Driving License') ? <>
					<FileUpload
						accept='image/*'
						onChange={(event) => fileChangedHandler(event, 'front', setIdProof, idProof, 300, 200, setIdErrProof, idErrProof)}
						name='front'
						id='front'
						idProof={idProof}
						formData={formData}
						required />

					<FileUpload
						accept='image/*'
						onChange={(event) => fileChangedHandler(event, 'back', setIdProof, idProof, 300, 200, setIdErrProof, idErrProof)}
						name='back'
						id='back'
						idProof={idProof}
						formData={formData}
						required />
					<div className='col-6'>
						{/* <span className="form-text text-danger h-40">{formError == 'home' &&  idErrProof?.front == undefined ? 'This field is required' : ''}</span> */}
					</div>
					<div className='col-6'>
						{/* <span className="form-text text-danger h-40">{formError == 'home' &&  idErrProof?.back == undefined ? 'This field is required' : ''}</span> */}

					</div>
					<small>
						(File type : jpeg, jpg, png)
					</small>

					<hr /></> : null}

			</div>
			<div className='row mt-4 d-none'>
				<div className="col">
					<div className='d-flex justify-content-between'>
						<label className="form-label">Vehicle Information <span className='text-danger'> *</span> <span className='ps-2 fw-normal'>Vehicles allowed per permit (5 max)</span></label>
						{<button type='button' className='btn btn-primary w-20 mb-2' disabled={vehicleListArray?.length >= 5} onClick={addVehicle}><i className='fa fa-plus'></i>Add New Vehicle</button>}
					</div>
				</div>
				{vehicleListArray?.map((vehicleListItem, vehicleListIndex) => {
					return (
						<div className='bg-light border p-2 mb-2 position-relative' key={vehicleListIndex}>
							<div className='row g-2 row-cols-2  row-cols-sm-3 row-cols-md-6' >
								<div className={'col'}>
									<label className='form-label' >License Plate <span className="text-danger">*</span></label>
									<input
										type="text"
										name='license_plate'
										className="form-control"
										placeholder="License Plate"
										maxLength={10}
										minLength={1}
										onKeyDown={restrictSpecialChar}
										value={vehicleListItem?.license_plate}
										onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
										aria-describedby="licenseplate" />
									<span className="form-text text-danger h-40">{formError == 'home' && !vehicleListArray?.[vehicleListIndex]?.license_plate != '' ? 'This field is required' : ''}</span>
								</div>
								<div className={'col'}>
									<label className='form-label' > Vehicle Make </label>
									<select autoComplete="off" name="make" placeholder="Make" disabled={vehicleCount > vehicleListIndex} onKeyDown={restrictSpecialChar} className="form-select form-control" value={vehicleListItem?.make} id="make" onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}>
										<option value="">Select Make</option>
										{(vehicleMakeList?.length > 0) && vehicleMakeList?.map((val, index) => {
											return (
												<option value={val?.name} key={index} >{val?.name}</option>
											)
										})}
									</select>
								</div>
								{vehicleListItem?.othermake ? <div className={'col'}>
									<label className='form-label' >Make </label>
									<input
										type="text"
										name='maketext'
										label="Make"
										className="form-control"
										placeholder="Make"
										required={true}
										disabled={vehicleCount > vehicleListIndex}
										onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
										maxLength={15}
										minLength={0}
										onKeyDown={restrictSpecialChar}
										value={vehicleListItem?.maketext}
										aria-describedby="color" />
								</div> : ''}

								{!vehicleListItem?.othermake ? <div className={'col'}>
									<label className='form-label' >Vehicle Model</label>
									<select className='form-select form-control' value={vehicleListItem?.model} placeholder="Model" name="model" id='state' onKeyDown={restrictSpecialChar} onChange={(e) => handleInputFieldsData(e, vehicleListIndex)} disabled={vehicleCount > vehicleListIndex ? true : vehicleListItem?.make ? false : true}>
										<option value="0">Select an option</option>
										{(vehicleListItem?.vehicleList?.length > 0) && vehicleListItem?.vehicleList?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
									</select>
								</div> : ''}

								{(vehicleListItem?.othermake || vehicleListItem?.othermodel) ? <div className={'col'}>
									<label className='form-label' >Model</label>
									<input
										type="text"
										name='modeltext'
										className="form-control"
										placeholder="Model"
										onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
										maxLength={15}
										minLength={4}
										onKeyDown={restrictSpecialChar}
										value={vehicleListItem?.modeltext}
										disabled={vehicleCount > vehicleListIndex}
										aria-describedby="model" />
								</div> : ''}

								{/* vehicle type  */}
								{isPermissionExist(accessPermissions, 'Get Vehicle Type') ?
									<div className={'w-full'}>
										<label className='form-label' >Vehicle Type <span className="text-danger">*</span></label>
										<select name='vehicle_type' autoComplete="off" className='form-select form-control' disabled={vehicleCount > vehicleListIndex} value={vehicleListItem?.vehicle_type} placeholder="vehicle_type" id='vehicle_type' onChange={(e) => handleInputFieldsData(e, vehicleListIndex)} onKeyDown={restrictSpecialChar}>
											<option value="">Select an option</option>
											{(vehicleDetailsList?.vehicletype?.length > 0) && vehicleDetailsList?.vehicletype?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
										</select>
										<span className="form-text text-danger">{formError == 'home' && !vehicleListArray?.[vehicleListIndex]?.vehicle_type != '' ? 'This field is required' : ''}</span>
									</div>
									: ''}
								{/* vehilce type end */}

								<div className={'col'}>
									<label className='form-label' >Color </label>
									<select name='color' autoComplete="off" className='form-select form-control' disabled={vehicleCount > vehicleListIndex} value={vehicleListItem?.color} placeholder="Color" id='color' onChange={(e) => handleInputFieldsData(e, vehicleListIndex)} onKeyDown={restrictSpecialChar}>
										<option value="0">Select an option</option>
										{(vehicleDetailsList?.color?.length > 0) && vehicleDetailsList?.color?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
									</select>
								</div>
								<div className={'col'}>
									<label className='form-label' >State/Province</label>
									<select className='form-select form-control' value={vehicleListItem?.state_id} disabled={vehicleCount > vehicleListIndex} placeholder="State" name="state_id" id='state_id' onKeyDown={restrictSpecialChar} onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}>
										<option value="0">Select an option</option>
										{(vehicleDetailsList?.state?.length > 0) && vehicleDetailsList?.state?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.id}>{item?.state_code}</option>)}
									</select>
								</div>
							</div>
							{(vehicleListArray?.length === vehicleListIndex) ?
								<div className='position-absolute top-0 right-0' >
									<a type="button" className=" small p-1 border-none text-danger text-white" onClick={(e) => removeVehicleMake(e, vehicleListIndex)}><i className='fa fa-trash'></i></a>
								</div> : (!(vehicleListArray?.length == 1) && vehicleListIndex !== -1) ?

									<div className='position-absolute top-0 right-0' ><a type="button" className=" small p-1 border-none text-danger text-white" onClick={(e) => removeVehicleMake(e, vehicleListIndex)}><i className='fa fa-trash'></i></a>

									</div> : null}
						</div>
					)
				})}
				<p className='text-danger'>{error}</p>
			</div>
			{/* Hide the facility details for diamond */}
			{selectedFaclity?.full_name &&
				<div className="bg-white border p-3 mt-1 mb-3">

					<div className="row align-items-center ">
						<div className='col-8 col-sm mb-sm-0 mb-3'>
							<h4 className="text-primary">{selectedFaclity?.full_name}</h4>
							<p className="m-0"><b>Entrance Address: </b>{`${selectedFaclity?.geolocations?.address_1}${selectedFaclity?.geolocations?.address_2 ? `, ${selectedFaclity?.geolocations?.address_2}` : ''}${selectedFaclity?.geolocations?.city ? `, ${selectedFaclity?.geolocations?.city}` : ''}${selectedFaclity?.geolocations?.state ? `, ${selectedFaclity?.geolocations?.state}` : ''}${selectedFaclity?.geolocations?.zip_code ? `, ${selectedFaclity?.geolocations?.zip_code}` : ''}`}</p>
							{(permitPrices?.permit_rate?.[0]?.permit_rate_criteria_mapping?.length > 0) ? perkingParkingTime(permitPrices?.permit_rate?.[0], true) : null}
						</div>

						{permitPrices?.permit_rate?.length > 0 ?
							<div className='col-4'>

								{/* {permitPrices?.permit_rate?.map((permitPricesItem, permitPricesIndex) => {
									return (
										<> */}
								<div className="text-success p-2">
									<input type="radio" className="btn-check" name="permit_rate" id={'btnradio1'} autoComplete="off" checked />
									<label className=" position-relative w-100 text-end" htmlFor={'btnradio1'}>
										{/* <h6 className="fw-bold mb-0 text-primary">Rates to start soon</h6> */}
										{/* <h2 className="fw-bold mb-0 text-primary">{permitPrices?.permit_rate?.[0]?.rate ? `$${permitPrices?.permit_rate?.[0]?.rate}` : ''}</h2> */}
										{/* <p className="mb-0 text-primary">{permitPrices?.permit_rate?.[0]?.name}</p> */}

									</label>

								</div>
								{/* </>
									)
								})} */}

							</div> : formData?.license_number &&
							<div className='col-sm-4 col-12'>

								<div className="text-success p-2">


									<label className=" position-relative w-100 text-end">
										<h2 className="fw-bold mb-0 text-primary">N/A</h2>
									</label>

								</div>
							</div>
						}

					</div>
				</div>
			}


		</div>
	)
}

Home.propTypes = {
	dispatch: PropTypes.func,
	data: PropTypes.object,
	events: PropTypes.object,
	loader: PropTypes.bool,
	getCard: PropTypes.func,
	passData: EMPTY_ARRAY,
	setPage: PropTypes.string,
	setIdProof: PropTypes.func,
	front: PropTypes.string,
	back: PropTypes.string,
	idProof: PropTypes.object,
	formData: PropTypes.object,
	setFormData: PropTypes.func,
	formError: PropTypes.string,
	partnerDetails: PropTypes.object,
	vehicleListArray: PropTypes.array,
	setVehicleListArray: PropTypes.array,
	setvehicleCount: PropTypes.number,
	vehicleCount: PropTypes.number,
	VehiclePrev: PropTypes.bool

}

Home.defaulProps = {
	dispatch: noop,
	data: EMPTY_OBJECT,
	events: EMPTY_OBJECT,
	loader: PropTypes.bool,
	getCard: PropTypes.func,
	passData: EMPTY_ARRAY,
	setPage: undefined,
	setIdProof: noop,
	front: undefined,
	back: undefined,
	idProof: EMPTY_OBJECT,
	formData: EMPTY_OBJECT,
	setFormData: noop,
	formError: undefined,
	partnerDetails: EMPTY_OBJECT,
	vehicleListArray: EMPTY_ARRAY,
	setVehicleListArray: noop,
	setvehicleCount: noop,
	vehicleCount: PropTypes.number,
	VehiclePrev: PropTypes.bool
}

function mapStateToProps({ basicInfoReducer }) {
	return {
		loader: basicInfoReducer?.loader,
	}
}
export default connect(mapStateToProps)(Home)